<div class="loggedOut">
  <h1>
    You are logged out!
  </h1>
</div>